module.exports = __webpack_public_path__ + "static/img/movie_c.acfac56b.png";